/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventTooltipsActions } from './IntegrationEventTooltipsActions';
import {
    IntegrationEventTooltipsActionsFromJSON,
    IntegrationEventTooltipsActionsFromJSONTyped,
    IntegrationEventTooltipsActionsToJSON,
} from './IntegrationEventTooltipsActions';
import type { IntegrationEventTooltipsResident } from './IntegrationEventTooltipsResident';
import {
    IntegrationEventTooltipsResidentFromJSON,
    IntegrationEventTooltipsResidentFromJSONTyped,
    IntegrationEventTooltipsResidentToJSON,
} from './IntegrationEventTooltipsResident';

/**
 * 
 * @export
 * @interface IntegrationEventTooltips
 */
export interface IntegrationEventTooltips {
    /**
     * 
     * @type {IntegrationEventTooltipsActions}
     * @memberof IntegrationEventTooltips
     */
    actions?: IntegrationEventTooltipsActions;
    /**
     * 
     * @type {IntegrationEventTooltipsResident}
     * @memberof IntegrationEventTooltips
     */
    resident?: IntegrationEventTooltipsResident;
    /**
     * 
     * @type {IntegrationEventTooltipsResident}
     * @memberof IntegrationEventTooltips
     */
    pcc_update?: IntegrationEventTooltipsResident;
}

/**
 * Check if a given object implements the IntegrationEventTooltips interface.
 */
export function instanceOfIntegrationEventTooltips(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventTooltipsFromJSON(json: any): IntegrationEventTooltips {
    return IntegrationEventTooltipsFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltips {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actions': !exists(json, 'actions') ? undefined : IntegrationEventTooltipsActionsFromJSON(json['actions']),
        'resident': !exists(json, 'resident') ? undefined : IntegrationEventTooltipsResidentFromJSON(json['resident']),
        'pcc_update': !exists(json, 'pcc_update') ? undefined : IntegrationEventTooltipsResidentFromJSON(json['pcc_update']),
    };
}

export function IntegrationEventTooltipsToJSON(value?: IntegrationEventTooltips | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actions': IntegrationEventTooltipsActionsToJSON(value.actions),
        'resident': IntegrationEventTooltipsResidentToJSON(value.resident),
        'pcc_update': IntegrationEventTooltipsResidentToJSON(value.pcc_update),
    };
}

